// Poslednji presek: 08.11.2023

import { ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseDataService } from './../../base-services/base-data.service';
import { BaseListComponent } from './../base-list-component';
import { BaseEntity } from './../../base-models/base-entity';
import { BaseTabsService } from './base-tabs.service';

export class BaseTabsListComponent<T extends BaseEntity> 
//extends BaseListComponent<T>
{
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected baseTabsService: BaseTabsService){
            //super(activatedRoute, baseDataService);
    }

    @ViewChild('tabSet', /* TODO: add static flag */ {static: true}) tabSet;

    AddItem(){
        this.baseTabsService.SetActiveTab('tab1');
    }

    EditItem(){
        this.baseTabsService.SetActiveTab('tab2');
    }
}
